import Fuse from 'fuse.js'


const useSearch = ({synonyms=[], boost=[]}) => {

  let curr_gender 
  let curr_page 
  let val_arr 


  const fuseOptions = {
    shouldSort: true,
    useExtendedSearch: true,
    threshold: 0.1,
    ignoreDiacritics: true,
    includeScore: true,
    includeMatches: true,
    keys: [
      {
        name: 'tags',
        weight: 1
      },
      {
        name: 'color',
        weight: 2
      },
      {
        name: 'colors',
        weight: 2
      },
      {
        name: 'gender',
        weight: 0.5
      }
    ]
  }

  const setupFuse = (products, setFuseIndex) => {
    const docs = products.map(x => {
      let tags = x.search.map(x => x.replace('womens-',''))
      tags = x.search.map(x => x.replace('mens-',''))
      return {
        id: x.mid,
        gender: x.gender,
        tags: [...new Set(tags)]
      }
    })
    setFuseIndex(new Fuse(docs, fuseOptions))
  }

  const buildVals = (val, fuseIndex, searchType) => {
    let hasSpaces = val.includes(' ')

    let search_q = val
    let val_arr = compact(val.split(' '))

    let curr_gend = searchType
    const gends = ['men', 'mens', "men's", 'women', 'womens', "women's"]
    let has_gend = val_arr.find(x => gends.includes(x.toLowerCase()))
    
    if (has_gend) {
      let search_gend = has_gend.toLowerCase().slice(0,1)
      if (search_gend !== curr_gend) {
        curr_gend = search_gend
      }
      val_arr = val_arr.filter(x => !gends.includes(x.toLowerCase()))
      search_q = val_arr.join(' ')
      if (val_arr.length === 1) hasSpaces = false
    }

    let prods = fuseIndex._docs
    if (!!curr_gend && curr_gend !== 'u') {
      const gends = [curr_gend,'u']
      prods = prods.filter(x => gends.includes(x.gender))
    }
    
    val_arr = val_arr.flatMap(term => {
      const has_syn = synonyms.find(x => x.includes(term) || x.includes(term.slice(0,-1)))
      if (!has_syn) return term
      return has_syn
    })
    
    const tees = ['teeshirt','teeshirts','tshirt','tshirts','teshirt']
    const noguess = ['red','green','blue','brown','white','black','grey','gray','shorts']
    const tags = [...new Set(prods.flatMap(x => x.tags) )]
    let sing_found = false
    let tagFuse

    if (val_arr.length === 1) sing_found = tags.includes(val_arr[0])

    tagFuse = new Fuse(tags.map(tag => ({ tag })), {
      threshold: 0.2,
      ignoreDiacritics: true,
      includeScore: true,
      keys: ['tag']
    })

    if (val_arr.some(x => tees.includes(x)) || tees.find(x => x.includes(search_q))) {
      val_arr = val_arr.filter(x => !tees.includes(x))
      val_arr.push('tee')
    }

    let user = val_arr.map(x => x)
    let fuzzy = val_arr.map(x => x)

    if (!hasSpaces && !tees.includes(search_q) && !noguess.includes(search_q)) {
      const matches = tagFuse.search(search_q)
      fuzzy = matches
        .filter(match => match.score < 0.2)
        .map(match => match.item.tag)
    }

    fuzzy = fuzzy.flatMap(tag => {
      const matches = tagFuse.search(tag).filter(match => match.score < 0.1)
      return matches.length > 0 ? matches.map(x => x.item.tag) : tag
    })

    fuzzy = fuzzy.filter(x => !user.includes(x))

    return {user, fuzzy}
  }

  const compact = (arr) => {
    return arr.filter(x => x !== null && x !== undefined && x !== '')
  }

  const searchProds = ({val, val_arr, products, fuseIndex, currSort, searchType, isPanel=false}) => {
    let search_obj = {val, products, fuseIndex, currSort, searchType, isPanel}
    const srchtest = localStorage.getItem('searchpls')

    let user = []
    if (val_arr.user.length > 0) {
      search_obj.vals = val_arr.user
      user = doSearch(search_obj)
    }
    const user_ids = user.map(x => x.mid)

    let fuzzy = []
    if (val_arr.fuzzy.length > 0) {
      search_obj.vals = val_arr.fuzzy
      doSearch(search_obj)
      fuzzy = fuzzy.filter(x => !user_ids.includes(x.mid))
    }

    let boosts = checkBoost({user, fuzzy})
    user = boosts.user
    fuzzy = boosts.fuzzy
    boosts = boosts.boosts

    let results
    if (currSort !== 'price') {
      user = sortProds(user, currSort)
      fuzzy = sortProds(fuzzy, currSort)
    } else {
      results = sortProds(boosts.concat(user).concat(fuzzy), currSort)
    }

    if (isPanel && srchtest) {
      let prods = currSort === 'price' ? results : boosts.concat(user).concat(fuzzy)
      results = plGroup({prods, products, vals: val_arr.user})
      return results
    }
    if (currSort === 'price') return [results]

    results = [user, fuzzy]
    if (boosts.length > 0) results.unshift(boosts)

    return results
  }

  const colors = [
    'red', 'green', 'blue', 'brown', 'tan', 
    'beige', 'offwhite', 'natural', 'white', 
    'black', 'grey', 'gray', 'navy', 'yellow',
    'orange', 'purple'
  ]
  const gend_tags = ['men', 'mens', "men's", 'women', 'womens', "women's"]

  const doSearch = ({val, vals, products, fuseIndex, currSort, searchType}) => {
    let hasSpaces = val.includes(' ')
    
    const gend_vals = val.split(' ')
    let has_gend = gend_vals.find(x => gend_tags.includes(x.toLowerCase()))
    if (has_gend && gend_vals.length === 2) {
      hasSpaces = false
    }

    let terms_arr = vals.map(x => { return { tags: x} })

    let fuse_obj = {$and: []}
    if (hasSpaces) {
      fuse_obj.$and.push(...terms_arr)
    } else {
      fuse_obj.$and.push({$or: terms_arr})
    }

    if (searchType) fuse_obj.$and.push( {$or: [{gender: `=${searchType}`}, {gender: `=u`}]} )
    let results = fuseIndex.search(fuse_obj)
    const gends = ['m','w','u']
    results = results.map(x => {
      return {
        ...x.item,
        score: Math.round((1 - x.score) * 100),
        matches: compact(x.matches.map(i => i.value).filter(i => !gends.includes(i)))
      }
    })

    let prods = []
    let some_terms = []
    let no_terms = []

    if (val.includes('shorts') && (!val.includes('slee') && !val.includes('skirt'))) {
      const shorts_skips = ['tee','shirt','teeshirt','tshirt','sleeve']
      results = results.filter(res => !res.tags.some(x => shorts_skips.includes(x)))
    }
    if (vals.includes('shirt') && !val.includes('tee')) {
      const shorts_skips = ['tee','tees']
      results = results.filter(res => !res.tags.some(x => shorts_skips.includes(x)))
    }

    results.forEach(fuseProd => {
      let tag_arr = compact(vals).map(term => {
        if (fuseProd.tags.includes(term)) return true 
        return !!compact(fuseProd.tags).find(x => x === term || x.slice(0,-1) === term || x.includes(term))
      }) 

      let prod_data = products.find(x => x.mid === fuseProd.id)
      if (!prod_data) return

      prod_data = {
        ...prod_data,
        broken: !!prod_data.broken,
        score: fuseProd.score,
        matches: fuseProd.matches
      }

      if (!tag_arr.includes(false) && !tag_arr.includes(null)) {
        prod_data.hits = vals.length
        prods.push(prod_data)
        return
      }
      if (tag_arr.includes(true)) {
        prod_data.hits = tag_arr.filter(x => !!x).length
        some_terms.push(prod_data)
        return
      }

      prod_data.hits = 0
      no_terms.push(prod_data)
      
    })

    return prods.concat(some_terms)
  }

  const checkBoost = ({user, fuzzy}) => {
    const doBoost = (prods) => {
      const fallback = {found: [], prods}

      if (prods.length < 1) return fallback
      const any_boost = boost.some(id => prods.find(x => x.mid === id))
      if (!any_boost) return fallback

      let found = prods.filter(x => boost.includes(x.mid))
      let reg_prods = prods.filter(x => !boost.includes(x.mid))
      found = found.sort((a, b) => boost.indexOf(a.mid) - boost.indexOf(b.mid))
      return {found, prods: reg_prods}
    }

    let boosts
    let user_obj = doBoost(user)
    boosts = user_obj.found

    let fuzz_obj = doBoost(fuzzy)
    boosts = boosts.concat(fuzz_obj.found)
    
    return {boosts: boosts, user: user_obj.prods, fuzzy: fuzz_obj.prods}
  }

  const plGroup = ({prods, products, vals}) => {
    const has_color = vals.some(term => colors.includes(term) || colors.includes(term.slice(0,-1)))
    const alt_q = vals.includes('short') || vals.includes('tall')

    let nprods = prods.flat()
    const pl_ids = [...new Set(nprods.map(x => x.pl_id))]

    let pl_groups = pl_ids.map(id => {
      let feats = nprods.filter(x => x.pl_id === id)
      if (feats.length < 1) return null
      if (!has_color) feats = feats.slice(0,1)

      const feat_ids = feats.map(x => x.mid)
      const pl_prods = products.filter(x => x.pl_id === id && !feat_ids.includes(x.mid))
      const is_alt = feats.find(x => x.isalt) || pl_prods.find(x => x.isalt)

      let price
      if (feats[0].handle.includes('gift')) {
        price = `25-$1,000`
      } else {
        price = feats[0].first_product_price
      }

      return {
        pl_id: id,
        pl_name: feats[0].pl_name,
        is_alt: is_alt,
        gender: feats[0].gender,
        price: price,
        feats: feats,
        products: pl_prods
      }
    })
    pl_groups = compact(pl_groups)
    if (!alt_q) pl_groups = pl_groups.filter(x => !x.is_alt)

    return pl_groups
  }

  const sortProds = (products, currSort, useHits=false) => {
    let prods = products
    if (currSort === 'recent') {
      if (!useHits) {
        prods = prods.sort((a, b) => {
          if (a.broken !== b.broken) return a.broken - b.broken
          return b.pub - a.pub
        })
      } else {
        prods = prods.sort((a, b) => {
          if (a.hits !== b.hits) return b.hits - a.hits
          if (a.broken !== b.broken) return a.broken - b.broken 
          return b.pub - a.pub
        })
      }
    } else if (currSort === 'best') {
      if (!useHits) {
        prods = prods.sort((a, b) => {
          if (a.broken !== b.broken) return a.broken - b.broken
          return a.best - b.best
        })
      } else {
        prods = prods.sort((a, b) => {
          if (a.hits !== b.hits) return b.hits - a.hits
          if (a.broken !== b.broken) return a.broken - b.broken 
          return a.best - b.best
        })
      }
    } else {
      prods = prods.sort((a, b) => a.first_product_price - b.first_product_price)
    }
    
    return prods
  }

  const searchPages = (pages) => {
    // // const pages_edited = pages.map(x => {
    // //   const name_arr = [...new Set((`${x.handle}${x.add ? `-${x.add}` : ''}`).replace(' ', '-').toLowerCase().split('-'))]
    // //   x['search'] = name_arr
    // // })
    // let page_search = pages.filter( page => {
    //   const search = !_.map(val_arr, x => page.search.includes(x) || _.map(page.search, y => y.includes(x)).includes(true) ).includes(false)
    //   return search ? page : false
    // })
    // if (curr_gender) {
    //   page_search = _.filter(page_search, x => x.gender === curr_gender)
    // }
    // if (!curr_gender && curr_page) {
    //   if ( curr_page === 'page' ) {
    //     page_search = _.filter(page_search, x => x.type !== 'store' && x.type !== 'collection')
    //   } else {
    //     page_search = _.filter(page_search, x => x.type === curr_page)
    //   }
    // }
    // return page_search
  }

  const saveSearch = (obj, vals) => {
    obj['val_arr'] = vals
    localStorage.setItem('search', JSON.stringify(obj))

    return true
  }

  const getSearch = () => {
    if (!localStorage.getItem('search')) return false

    const obj = JSON.parse(localStorage.getItem('search'))
    val_arr = obj.val_arr

    return obj
  }

  return { setupFuse, buildVals, searchProds, searchPages, saveSearch, getSearch }
};

export default useSearch

